import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { infinityNumberColDef, infinityTextColDef } from "src/app/utils/aggrid/infinityLoadHelper";
import { CellFlag } from "src/app/components";

export default function useKeywordsRanklvl1GridColumns(): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "keyword",
            ...infinityTextColDef(formatMessage({ id: "keywords.grid.col.keyword" })),
            checkboxSelection: true,
            width: 200,
            pinned: "left",
        },
        {
            field: "lang",
            ...infinityTextColDef(formatMessage({ id: "keywords.grid.col.lang" })),
            cellRenderer: ({ data }: any) => <CellFlag lang={data.lang} />,
            pinned: "left",
            minWidth: 50,
            maxWidth: 50,
        },
        {
            field: "volume",
            ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.volume" })),
            pinned: "left",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "kd",
            ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.kd" })),
            minWidth: 60,
            maxWidth: 60,
        },
        {
            field: "thematic",
            ...infinityTextColDef(formatMessage({ id: "keywords.grid.col.thematic" })),
            minWidth: 107,
            maxWidth: 107,
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos2" }),
            children: [
                {
                    field: "pos2.bl",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.bl" })),
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos2?.bl || 0} (${data?.pos2?.tf || 0})`,
                    minWidth: 60,
                    maxWidth: 60,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                },
                {
                    field: "pos2.words",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.words" })),
                    valueFormatter: ({ data }: any) => (data.pos2?.words ? data.pos2?.words : 0),
                    minWidth: 65,
                    maxWidth: 65,
                    hide: true,
                },
                {
                    field: "pos2.traffic",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.traffic" })),
                    valueFormatter: ({ data }: any) =>
                        data.pos2?.traffic ? data.pos2?.traffic : 0,
                    minWidth: 80,
                    maxWidth: 80,
                },
                {
                    field: "pos2.da",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.da" })),
                    valueFormatter: ({ data }: any) => (data.pos2?.da ? data.pos2?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                    minWidth: 60,
                    maxWidth: 60,
                },
            ],
        },

        {
            headerName: formatMessage({ id: "keywords.grid.col.pos4" }),
            children: [
                {
                    field: "pos4.bl",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.bl" })),
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos4?.bl || 0} (${data?.pos4?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                    maxWidth: 60,
                    minWidth: 60,
                },
                {
                    field: "pos4.words",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.words" })),
                    valueFormatter: ({ data }: any) => (data.pos4?.words ? data.pos4?.words : 0),
                    hide: true,
                    minWidth: 65,
                    maxWidth: 65,
                },
                {
                    field: "pos4.traffic",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.traffic" })),
                    valueFormatter: ({ data }: any) =>
                        data.pos4?.traffic ? data.pos4?.traffic : 0,
                    minWidth: 80,
                    maxWidth: 80,
                },
                {
                    field: "pos4.da",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.da" })),
                    valueFormatter: ({ data }: any) => (data.pos4?.da ? data.pos4?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                    minWidth: 60,
                    maxWidth: 60,
                },
            ],
        },

        {
            headerName: formatMessage({ id: "keywords.grid.col.pos6" }),
            children: [
                {
                    field: "pos6.bl",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.bl" })),
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos6?.bl || 0} (${data?.pos6?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                    minWidth: 60,
                    maxWidth: 60,
                },
                {
                    field: "pos6.words",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.words" })),
                    valueFormatter: ({ data }: any) => (data.pos6?.words ? data.pos6?.words : 0),
                    hide: true,
                    minWidth: 65,
                    maxWidth: 65,
                },
                {
                    field: "pos6.traffic",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.traffic" })),
                    valueFormatter: ({ data }: any) =>
                        data.pos6?.traffic ? data.pos6?.traffic : 0,
                    minWidth: 80,
                    maxWidth: 80,
                },
                {
                    field: "pos6.da",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.da" })),
                    valueFormatter: ({ data }: any) => (data.pos6?.da ? data.pos6?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                    minWidth: 60,
                    maxWidth: 60,
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos8" }),
            children: [
                {
                    field: "pos8.bl",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.bl" })),
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos8?.bl || 0} (${data?.pos8?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                    maxWidth: 60,
                    minWidth: 60,
                },
                {
                    field: "pos8.words",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.words" })),
                    valueFormatter: ({ data }: any) => (data.pos8?.words ? data.pos8?.words : 0),
                    hide: true,
                    minWidth: 65,
                    maxWidth: 65,
                },
                {
                    field: "pos8.traffic",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.traffic" })),
                    valueFormatter: ({ data }: any) =>
                        data.pos8?.traffic ? data.pos8?.traffic : 0,
                    minWidth: 80,
                    maxWidth: 80,
                },
                {
                    field: "pos8.da",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.da" })),
                    valueFormatter: ({ data }: any) => (data.pos8?.da ? data.pos8?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                    maxWidth: 60,
                    minWidth: 60,
                },
            ],
        },
        {
            headerName: formatMessage({ id: "keywords.grid.col.pos10" }),
            children: [
                {
                    field: "pos10.bl",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.bl" })),
                    valueFormatter: ({ data }: any) =>
                        `${data?.pos10?.bl || 0} (${data?.pos10?.tf || 0})`,
                    cellStyle: { borderLeft: "1px solid var(--ag-header-column-separator-color)" },
                    maxWidth: 60,
                    minWidth: 60,
                },
                {
                    field: "pos10.words",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.words" })),
                    valueFormatter: ({ data }: any) => (data.pos10?.words ? data.pos10?.words : 0),
                    hide: true,
                    maxWidth: 65,
                    minWidth: 65,
                },
                {
                    field: "pos10.traffic",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.traffic" })),
                    valueFormatter: ({ data }: any) =>
                        data.pos10?.traffic ? data.pos10?.traffic : 0,
                    minWidth: 80,
                    maxWidth: 80,
                },
                {
                    field: "pos10.da",
                    ...infinityNumberColDef(formatMessage({ id: "keywords.grid.col.da" })),
                    valueFormatter: ({ data }: any) => (data.pos10?.da ? data.pos10?.da : 0),
                    cellStyle: { borderRight: "1px solid var(--ag-header-column-separator-color)" },
                    maxWidth: 60,
                    minWidth: 60,
                },
            ],
        },
    ];

    return gridColumns;
}
